// extracted by mini-css-extract-plugin
module.exports = {"App":"style_App__1l-VK","container":"style_container__1vSd0","title":"style_title__30qEL"};